/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './CreateCustomAccountsGroupModal.scss';

import React from 'react';
import CreateCustomAccountGroupTable from './CreateCustomAccountGroupTable';

const CreateCustomAccountsGroup = ({ close, isEdit, deleteHandler }) => {
  return (
    <div className="custom-account-group-modal-container">
      <div className="custom-account-group-modal-body">
        <CreateCustomAccountGroupTable
          close={close}
          isEdit={isEdit}
          deleteHandler={deleteHandler}
        />
      </div>
    </div>
  );
};

export default CreateCustomAccountsGroup;
